/* =========================================================
   CHILDREN OF DANTE · Shopify theme behaviour
   Every feature checks its elements exist, so this one file
   runs safely on every page. Cart uses Shopify's AJAX API.
   ========================================================= */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const S = window.STORE || {}, WORLD = (window.WORLD && window.WORLD.length) ? window.WORLD : [{ word: "British", city: "London", tz: "Europe/London" }];
  const R = S.routes || { root: "/", cart: "/cart", cartAdd: "/cart/add", cartChange: "/cart/change" };
  // ?motion=1 forces full motion (for testing on machines with Reduce Motion switched on)
  const reduce = /[?&]motion=0/.test(location.search);
  const fine = matchMedia("(pointer: fine)").matches;
  const G = window.gsap, ST = window.ScrollTrigger;
  const anim = !!(G && ST) && !reduce;
  if (anim) G.registerPlugin(ST); else document.documentElement.classList.add("no-anim");
  const esc = (t) => String(t).replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" })[c]);

  // Money in the SHOPPER's currency (Shopify Markets converts prices per country).
  // The cart API reports which currency it used; format with that, e.g. £69.99, €82.00, $89.00.
  let shopperCurrency = S.currency;
  const money = (cents, currency) => {
    const cur = currency || shopperCurrency;
    if (cur) {
      try { return new Intl.NumberFormat(S.locale || undefined, { style: "currency", currency: cur }).format((cents || 0) / 100); } catch (e) {}
    }
    const fmt = S.moneyFormat || "£{{amount}}";
    const n = (cents || 0) / 100;
    const two = n.toFixed(2), parts = two.split(".");
    const withSep = (int, sep) => int.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      if (k === "amount_no_decimals") return withSep(String(Math.round(n)), ",");
      if (k === "amount_with_comma_separator") return withSep(parts[0], ".") + "," + parts[1];
      if (k === "amount_no_decimals_with_comma_separator") return withSep(String(Math.round(n)), ".");
      return withSep(parts[0], ",") + "." + parts[1];
    });
  };

  /* ---------- Toast ---------- */
  let toastT;
  const toast = (msg) => { const t = $("#toast"); if (!t) return; t.textContent = msg; t.classList.add("show"); clearTimeout(toastT); toastT = setTimeout(() => t.classList.remove("show"), 2400); };

  /* ---------- Boot (home, once per session) ---------- */
  const boot = $("#boot");
  let BOOT = 0.15;
  if (boot) {
    let first = true;
    try { first = !sessionStorage.getItem("cod-boot"); sessionStorage.setItem("cod-boot", "1"); } catch (e) {}
    if (!first || reduce) boot.remove();
    else {
      // short and snappy: the bar fills in 0.9s, then the gate opens straight into the hero intro
      BOOT = 1.05;
      setTimeout(() => boot.classList.add("done"), 950);
      boot.addEventListener("click", () => boot.classList.add("skip"));
      boot.addEventListener("animationend", (e) => e.animationName === "boot-out" && boot.remove());
    }
  }

  /* ---------- Nav ---------- */
  const nav = $("#nav");
  if (nav && nav.hasAttribute("data-transparent")) {
    const solid = () => nav.classList.toggle("is-solid", scrollY > 40);
    addEventListener("scroll", solid, { passive: true });
    solid();
  }
  $$("#navMobile a").forEach((a) => a.addEventListener("click", () => ($("#navMobile").open = false)));
  document.addEventListener("click", (e) => { const m = $("#navMobile"); if (m && m.open && !m.contains(e.target)) m.open = false; });

  /* ---------- Sky ---------- */
  const skyEl = $("#sky");
  const sky = skyEl && window.SKY ? SKY.mount(skyEl, { onSnapshot: (url) => document.documentElement.style.setProperty("--sky-img", `url(${url})`) }) : null;

  /* ---------- Hero: world-tour word ---------- */
  const title = $("#heroTitle");
  const chars = (word) => `<span class="ln">${[...word].map((c) => `<span class="ch">${esc(c)}</span>`).join("")}</span>`;
  const wide = matchMedia("(min-width: 761px)");
  const fitTitle = () => {
    if (!title) return;
    title.style.fontSize = "";
    const keep = title.innerHTML;
    const avail = title.parentElement.clientWidth * (wide.matches ? 0.94 : 0.92);
    const base = parseFloat(getComputedStyle(title).fontSize);
    let w = 0;
    for (const c of WORLD) { title.innerHTML = chars(c.word.toUpperCase()); w = Math.max(w, title.scrollWidth); }
    title.style.fontSize = Math.min((base * avail) / w, base * 1.3, innerHeight * 0.3) + "px";
    title.innerHTML = keep;
  };

  if (title) {
    let wi = 0;
    title.innerHTML = chars(WORLD[0].word.toUpperCase());
    $("#subCountry") && ($("#subCountry").textContent = WORLD[0].word);
    fitTitle();
    const hudCity = $("#hudCity"), hudClock = $("#hudClock");
    const clock = () => {
      const w = WORLD[wi];
      if (hudCity) hudCity.textContent = w.city.toUpperCase();
      try { if (hudClock) hudClock.textContent = new Date().toLocaleTimeString("en-GB", { timeZone: w.tz, hour12: false }); } catch (e) {}
    };
    clock();
    setInterval(clock, 1000);

    const swapWord = () => {
      wi = (wi + 1) % WORLD.length;
      const next = WORLD[wi].word;
      const sub = $("#subCountry");
      if (!anim) { title.innerHTML = chars(next.toUpperCase()); if (sub) sub.textContent = next; clock(); return; }
      G.timeline()
        .to("#heroTitle .ch", { yPercent: -110, rotate: -5, duration: 0.55, ease: "power3.in", stagger: 0.025 })
        .to(sub, { opacity: 0, y: -10, duration: 0.3, ease: "power2.in" }, 0.1)
        .add(() => { title.innerHTML = chars(next.toUpperCase()); if (sub) sub.textContent = next; clock(); })
        .from("#heroTitle .ch", { yPercent: 110, rotate: 6, duration: 0.9, ease: "expo.out", stagger: 0.03 })
        .to(sub, { opacity: 1, y: 0, duration: 0.6, ease: "expo.out" }, "<0.15");
    };

    const typeSub = (delay) => {
      const el = $("#sub");
      if (!el) return;
      const parts = [...el.childNodes].map((n) => ({ el: n.nodeType === 1 ? n : null, text: n.textContent }));
      const caret = document.createElement("span");
      caret.className = "caret";
      el.textContent = "";
      const nodes = parts.map((p) => { const node = p.el ? p.el.cloneNode(false) : document.createTextNode(""); el.append(node); return { node, text: p.text }; });
      el.append(caret);
      let ni = 0, ci = 0;
      setTimeout(function step() {
        const n = nodes[ni];
        if (!n) { setTimeout(() => caret.remove(), 1400); return; }
        ci++;
        n.node.textContent = n.text.slice(0, ci);
        n.node.after(caret);
        if (ci >= n.text.length) { ni++; ci = 0; }
        setTimeout(step, 30);
      }, delay * 1000);
    };

    if (anim) {
      const intro = G.timeline({ delay: BOOT, defaults: { ease: "expo.out" } })
        .from("#sky", { scale: 1.14, duration: 2.4 }, 0)
        .from("#heroChar", { yPercent: 14, scale: 0.92, opacity: 0, duration: 1.8 }, 0.1)
        .from("#heroTitle .ch", { yPercent: 110, rotate: 6, duration: 1.3, stagger: 0.035 }, 0.25)
        .from("#heroVery", { y: 30, opacity: 0, duration: 1.1 }, 0.7)
        .from(".hero__ctas", { y: 24, opacity: 0, duration: 0.9 }, 1.4)
        .from(".hud", { opacity: 0, duration: 0.8 }, 1.6)
        .add(() => setInterval(swapWord, 3600), 2.6);
      // safety net: if the browser ever stalls animation frames, never leave the hero half-hidden
      setTimeout(() => { if (intro.progress() < 1) intro.progress(1); }, (BOOT + 3.5) * 1000);
      typeSub(BOOT + 0.9);
      G.timeline({ scrollTrigger: { trigger: "[data-hero]", start: "top top", end: "bottom top", scrub: true, onUpdate: (s) => sky && sky.scroll(s.progress) } })
        .to("#sky", { yPercent: 10, ease: "none" }, 0)
        .to("#heroWord", { yPercent: -55, ease: "none" }, 0)
        .to("#heroChar", { yPercent: 8, scale: 1.06, ease: "none" }, 0)
        .to("#heroBottom", { yPercent: 60, opacity: 0, ease: "none" }, 0);
      if (fine) {
        const hero = $("[data-hero]");
        const wx = G.quickTo("#heroTitle", "x", { duration: 1, ease: "power3" }), wy = G.quickTo("#heroTitle", "y", { duration: 1, ease: "power3" });
        const cx = G.quickTo("#heroChar img", "x", { duration: 1.1, ease: "power3" }), cr = G.quickTo("#heroChar img", "rotationY", { duration: 1.1, ease: "power3" });
        hero.addEventListener("pointermove", (e) => {
          const nx = e.clientX / innerWidth - 0.5, ny = e.clientY / innerHeight - 0.5;
          wx(nx * 30); wy(ny * 14); cx(nx * 12); cr(nx * 5);
          sky && sky.pointer(nx, -ny);
        });
        hero.addEventListener("pointerleave", () => { wx(0); wy(0); cx(0); cr(0); sky && sky.pointer(0, 0); });
      }
      const trail = $(".hero__trail");
      if (trail) {
        const fly = () => G.timeline().set(trail, { strokeDashoffset: 2600, opacity: 0.9 }).to(trail, { strokeDashoffset: 0, duration: 4.5, ease: "power1.inOut" }).to(trail, { opacity: 0, duration: 3, ease: "power1.in" }, "-=1.2");
        G.delayedCall(BOOT + 1.6, function loop() { fly(); G.delayedCall(11, loop); });
      }
    } else {
      setInterval(swapWord, 3600);
    }
  }

  /* ---------- Marquee ---------- */
  const mTrack = $("#marqueeTrack");
  if (mTrack && anim) {
    const loop = G.to(mTrack, { xPercent: -50, ease: "none", duration: 60, repeat: -1 });
    const skew = G.quickTo(mTrack, "skewX", { duration: 0.5, ease: "power3" });
    let dir = 1, t;
    ST.create({
      trigger: mTrack.parentElement, start: "top bottom", end: "bottom top",
      onUpdate(self) {
        const v = self.getVelocity();
        dir = self.direction;
        G.to(loop, { timeScale: dir * (1 + Math.min(Math.abs(v) / 300, 5)), duration: 0.2, overwrite: true });
        skew(G.utils.clamp(-12, 12, v / -120));
        clearTimeout(t);
        t = setTimeout(() => { G.to(loop, { timeScale: dir, duration: 1 }); skew(0); }, 140);
      },
    });
  }

  /* ---------- Cart (Shopify AJAX) ---------- */
  const cartEl = $("#cart"), scrim = $("#scrim");
  const openCart = () => {
    if (!cartEl) return;
    scrim.hidden = false;
    requestAnimationFrame(() => scrim.classList.add("on"));
    cartEl.classList.add("open");
    cartEl.setAttribute("aria-hidden", "false");
    $("#cartClose").focus();
  };
  const closeCart = () => {
    if (!cartEl) return;
    scrim.classList.remove("on");
    cartEl.classList.remove("open");
    cartEl.setAttribute("aria-hidden", "true");
    setTimeout(() => (scrim.hidden = true), 400);
  };
  const setCount = (n, bump) => {
    const c = $("#cartCount");
    if (!c) return;
    c.textContent = n;
    if (bump) { c.classList.remove("bump"); void c.offsetWidth; c.classList.add("bump"); }
  };
  const renderCart = (cart) => {
    if (cart.currency) shopperCurrency = cart.currency;
    setCount(cart.item_count);
    const items = $("#cartItems");
    if (!items) return;
    items.innerHTML = cart.items.length
      ? cart.items.map((it) => `<div class="cline">
          ${(() => { const src = it.image || (it.featured_image && it.featured_image.url) || S.fallbackImage; return src ? `<img src="${src + (src.includes("?") ? "&" : "?") + "width=200"}" alt="" width="76" height="94" loading="lazy">` : "<span></span>"; })()}
          <div><a class="cline__name" href="${it.url}">${esc(it.product_title)}</a>
            ${it.variant_title ? `<div class="cline__meta">${esc(it.variant_title)}</div>` : ""}
            <div class="cline__qty"><button type="button" data-key="${it.key}" data-q="${it.quantity - 1}" aria-label="One less">−</button><span>${it.quantity}</span><button type="button" data-key="${it.key}" data-q="${it.quantity + 1}" aria-label="One more">+</button></div></div>
          <div class="cline__right"><div class="cline__price">${money(it.final_line_price)}</div><button type="button" class="cline__rm" data-key="${it.key}" data-q="0">Remove</button></div>
        </div>`).join("")
      : `<div class="cart__empty"><em>Nothing packed.</em>Your cart is empty.</div>`;
    $("#cartTotal").textContent = money(cart.total_price);
    const co = $("#checkoutBtn");
    if (co) co.toggleAttribute("aria-disabled", !cart.item_count), co.classList.toggle("is-disabled", !cart.item_count);
  };
  const getCart = () => fetch(R.cart + ".js", { headers: { Accept: "application/json" } }).then((r) => r.json());
  const refreshCart = () => getCart().then(renderCart).catch(() => {});
  if (cartEl) {
    $("#cartBtn") && $("#cartBtn").addEventListener("click", (e) => { e.preventDefault(); refreshCart(); openCart(); });
    $("#cartClose").addEventListener("click", closeCart);
    scrim.addEventListener("click", closeCart);
    addEventListener("keydown", (e) => e.key === "Escape" && closeCart());
    $("#cartItems").addEventListener("click", (e) => {
      const b = e.target.closest("button[data-key]");
      if (!b) return;
      b.disabled = true;
      fetch(R.cartChange + ".js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ id: b.dataset.key, quantity: Math.max(0, +b.dataset.q) }) })
        .then((r) => r.json()).then(renderCart).catch(() => toast("Couldn't update the cart"));
    });
    addEventListener("pageshow", (e) => e.persisted && refreshCart());
  }

  /* ---------- Product blocks ---------- */
  $$("[data-product-root]").forEach((root) => {
    const mainImg = $("#mainImg", root);
    // gallery
    $$("[data-thumb]", root).forEach((b) => b.addEventListener("click", () => {
      if (!mainImg) return;
      mainImg.classList.add("swap");
      setTimeout(() => { mainImg.removeAttribute("srcset"); mainImg.src = b.dataset.thumb; if (b.dataset.alt) mainImg.alt = b.dataset.alt; mainImg.classList.remove("swap"); }, 220);
      $$("[data-thumb]", root).forEach((x) => x.setAttribute("aria-current", x === b));
    }));
    // tilt + light
    const stage = $("[data-stage]", root), tilt = $("#tilt", root);
    if (stage && tilt && !reduce) {
      const to = (nx, ny) => { tilt.style.transform = `rotateY(${nx * 14}deg) rotateX(${-ny * 10}deg)`; stage.style.setProperty("--mx", (nx + 0.5) * 100 + "%"); stage.style.setProperty("--my", (ny + 0.5) * 100 + "%"); };
      stage.addEventListener("pointermove", (e) => { const r = stage.getBoundingClientRect(); to((e.clientX - r.left) / r.width - 0.5, (e.clientY - r.top) / r.height - 0.5); });
      stage.addEventListener("pointerleave", () => to(0, -0.2));
    }
    if (anim && stage) G.from(stage, { clipPath: "inset(18% 12% 18% 12% round 28px)", scale: 0.94, duration: 1.4, ease: "expo.out", scrollTrigger: { trigger: stage, start: "top 85%", once: true } });

    // size chart
    const chart = $("#sizeChart");
    $$("[data-size-chart-open]", root).forEach((b) => b.addEventListener("click", () => chart && chart.showModal()));
    chart && chart.addEventListener("click", (e) => { if (e.target === chart || e.target.closest("[data-close]")) chart.close(); });

    const form = $("#productForm", root);
    if (!form) return;
    const variants = JSON.parse(($("[data-variants]", form) || {}).textContent || "[]");
    const idInput = $("[data-variant-id]", form);
    const addBtn = $("#addBtn", form), addLabel = $("#addLabel", form);
    const needsSize = addBtn && addBtn.dataset.needsSize === "true";
    let chosen = !needsSize;
    $$("#sizeRow input", form).forEach((inp) => inp.addEventListener("change", () => {
      chosen = true;
      idInput.value = inp.value;
      const lab = $("#sizeLabel", form);
      if (lab) lab.textContent = inp.dataset.label;
      const v = variants.find((x) => String(x.id) === inp.value);
      if (v) {
        const price = $("#pPrice", root);
        if (price) price.innerHTML = v.price;
        if (v.image && mainImg) { mainImg.removeAttribute("srcset"); mainImg.src = v.image; }
      }
    }));
    const needSize = () => {
      if (chosen) return false;
      const f = $("#sizes", form);
      if (f) { f.classList.remove("shake"); void f.offsetWidth; f.classList.add("shake"); }
      toast("Pick a size first");
      return true;
    };
    const flyToCart = (done) => {
      const btn = $("#cartBtn");
      if (!anim || !mainImg || !btn) return done();
      const a = mainImg.getBoundingClientRect(), b = btn.getBoundingClientRect();
      const f = document.createElement("img");
      f.src = mainImg.currentSrc || mainImg.src;
      f.className = "flyer";
      const w = Math.min(a.width, 240);
      Object.assign(f.style, { width: w + "px", left: a.left + a.width / 2 - w / 2 + "px", top: a.top + a.height / 2 - w * 0.6 + "px" });
      document.body.append(f);
      const dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + b.height / 2 - (a.top + a.height / 2);
      G.timeline({ onComplete() { f.remove(); done(); } })
        .to(f, { x: dx, duration: 0.85, ease: "power2.inOut" }, 0)
        .to(f, { y: dy, duration: 0.85, ease: "back.in(1.4)" }, 0)
        .to(f, { scale: 0.12, rotate: 25, duration: 0.85, ease: "power2.in" }, 0)
        .to(f, { opacity: 0.2, duration: 0.2 }, 0.65);
    };
    const add = () => fetch(R.cartAdd + ".js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: [{ id: +idInput.value, quantity: 1 }] }) })
      .then(async (r) => { const d = await r.json(); if (!r.ok) throw new Error(d.description || d.message || "Couldn't add to cart"); return d; });

    form.addEventListener("submit", (e) => {
      e.preventDefault();
      if (needSize() || addBtn.disabled) return;
      addBtn.disabled = true;
      add().then(() => {
        addLabel.textContent = "Added ✓";
        flyToCart(() => {
          getCart().then((c) => { renderCart(c); setCount(c.item_count, true); });
          toast("Packed: " + (($("#pTitle", root) || {}).textContent || "Added"));
          setTimeout(() => { addLabel.textContent = "Add to cart"; addBtn.disabled = false; }, 1400);
        });
      }).catch((err) => { toast(err.message); addBtn.disabled = false; });
    });
    const buyNow = $("#buyNow", form);
    buyNow && buyNow.addEventListener("click", () => {
      if (needSize()) return;
      buyNow.disabled = true;
      add().then(() => (location.href = R.root + "checkout")).catch((err) => { toast(err.message); buyNow.disabled = false; });
    });
  });

  /* ---------- Sightings reel ---------- */
  const reelPin = $("#reelPin");
  if (reelPin) {
    if (anim) {
      const mm = G.matchMedia();
      mm.add("(min-width: 900px)", () => {
        const track = $("#reelTrack");
        const dist = () => Math.max(0, track.scrollWidth - innerWidth);
        const move = G.to(track, { x: () => -dist(), ease: "none", scrollTrigger: { trigger: reelPin, start: "center center", end: () => "+=" + dist(), pin: true, scrub: 0.8, invalidateOnRefresh: true } });
        $$(".frame", track).forEach((f) => {
          const img = $(".frame__img img", f);
          img && G.fromTo(img, { xPercent: -5 }, { xPercent: 5, ease: "none", scrollTrigger: { trigger: f, containerAnimation: move, start: "left right", end: "right left", scrub: true } });
          G.from($(".frame__img", f), { clipPath: "inset(0 0 0 100% round 22px)", ease: "none", scrollTrigger: { trigger: f, containerAnimation: move, start: "left 100%", end: "left 55%", scrub: true } });
          G.from($(".frame__cap", f), { y: 30, opacity: 0, ease: "none", scrollTrigger: { trigger: f, containerAnimation: move, start: "left 70%", end: "left 40%", scrub: true } });
        });
      });
      mm.add("(max-width: 899px)", () => { reelPin.style.overflowX = "auto"; return () => (reelPin.style.overflowX = ""); });
    } else reelPin.style.overflowX = "auto";
    if (anim) G.from(".reel__head > *", { y: 40, opacity: 0, duration: 1, ease: "expo.out", stagger: 0.1, scrollTrigger: { trigger: ".reel__head", start: "top 85%", once: true } });
  }

  /* ---------- Passport ---------- */
  const detail = $("#stampDetail");
  if (detail) {
    const showStamp = (id, animate) => {
      const tpl = $(`template[data-detail="${id}"]`);
      if (!tpl) return;
      $$(".stamp--visited").forEach((s) => s.setAttribute("aria-pressed", s.dataset.id === id));
      detail.innerHTML = "";
      detail.append(tpl.content.cloneNode(true));
      if (anim && animate) G.from("#stampDetail > *", { y: 30, opacity: 0, duration: 0.8, ease: "expo.out", stagger: 0.06 });
    };
    $$(".stamp--visited").forEach((s) => s.addEventListener("click", () => showStamp(s.dataset.id, true)));
    const firstStamp = $(".stamp--visited");
    if (firstStamp) showStamp(firstStamp.dataset.id, false);
    if (anim && $("#book")) {
      G.set(".stamp", { opacity: 0 });
      ST.create({
        trigger: "#book", start: "top 70%", once: true,
        onEnter() {
          const tl = G.timeline();
          $$(".stamp").forEach((s, i) => {
            const rot = parseFloat(s.style.getPropertyValue("--rot")) || 0;
            tl.fromTo(s, { scale: 1.9, opacity: 0, rotate: rot - 18 }, { scale: 1, opacity: 1, rotate: rot, duration: 0.45, ease: "power4.in", clearProps: "transform" }, 0.4 + i * 0.18)
              .to("#book", { x: 2, y: 1, duration: 0.04, yoyo: true, repeat: 3, ease: "none" }, 0.4 + i * 0.18 + 0.45);
          });
          G.from("#stampDetail > *", { y: 40, opacity: 0, duration: 1, ease: "expo.out", stagger: 0.08, delay: 0.6 });
        },
      });
      G.from("#book", { y: 80, opacity: 0, duration: 1.4, ease: "expo.out", scrollTrigger: { trigger: "#book", start: "top 92%", once: true } });
    }
    // if the sign-up form just posted, bring it into view
    if (/customer_posted=true|form_type=customer/.test(location.search + location.hash) && $("#notify")) $("#notify").scrollIntoView();
  }

  /* ---------- Comms dialogue ---------- */
  const dialog = $("#dialog");
  if (dialog) {
    const LINES = JSON.parse(($("#commsLines") || {}).textContent || "[]");
    const DONE = JSON.parse(($("#commsDone") || {}).textContent || '""');
    const lineEl = $("#line"), speaker = $("#speaker"), lineNo = $("#lineNo");
    let li = 0, typing = null, full = (LINES[0] || [])[1] || "";
    const done = () => { if (li === LINES.length - 1) dialog.classList.add("choosing"); };
    const show = (i) => {
      if (!LINES[i]) return;
      li = i;
      const [who, text] = LINES[i];
      full = text;
      speaker.textContent = who;
      lineNo.textContent = `${i + 1} / ${LINES.length}`;
      dialog.classList.remove("choosing");
      clearInterval(typing);
      if (reduce) { lineEl.textContent = text; return done(); }
      let n = 0;
      lineEl.textContent = "";
      typing = setInterval(() => { n++; lineEl.textContent = text.slice(0, n); if (n >= text.length) { clearInterval(typing); typing = null; done(); } }, 26);
    };
    const advance = () => {
      if (dialog.classList.contains("choosing")) return;
      if (typing) { clearInterval(typing); typing = null; lineEl.textContent = full; return done(); }
      if (li < LINES.length - 1) show(li + 1); else done();
    };
    dialog.addEventListener("click", (e) => { if (!e.target.closest(".choice")) advance(); });
    dialog.addEventListener("keydown", (e) => { if ((e.key === "Enter" || e.key === " ") && e.target === dialog) { e.preventDefault(); advance(); } });
    $$(".choice", dialog).forEach((c) => c.addEventListener("click", (e) => {
      if (c.dataset.choice === "buy") {
        e.preventDefault();
        lineEl.textContent = DONE;
        dialog.classList.remove("choosing");
        const target = $("#drop");
        setTimeout(() => target && target.scrollIntoView({ behavior: reduce ? "auto" : "smooth" }), 500);
        setTimeout(() => show(0), 2200);
      } else show(1);
    }));
    let talked = false;
    new IntersectionObserver(([e]) => { if (e.isIntersecting && !talked) { talked = true; show(0); } }, { threshold: 0.5 }).observe(dialog);
    if (anim) G.to("#commsBg", { yPercent: 10, ease: "none", scrollTrigger: { trigger: "#comms", start: "top bottom", end: "bottom top", scrub: true } });
  }

  /* ---------- Account: log in <-> recover password panels ---------- */
  const panels = $$(".acct-panel");
  if (panels.length) {
    const showPanel = (id) => panels.forEach((p) => (p.hidden = p.id !== id));
    $$("[data-show]").forEach((a) => a.addEventListener("click", (e) => { e.preventDefault(); showPanel(a.dataset.show); history.replaceState(null, "", a.getAttribute("href")); }));
    if (location.hash === "#recover" && $("#recoverPanel")) showPanel("recoverPanel");
  }

  /* ---------- Reveals ---------- */
  if (anim) {
    $$(".info, .passport__head, .comms__inner, .notify").forEach((g) => {
      const its = g.classList.contains("reveal") ? [g] : $$(".reveal", g);
      its.length && G.from(its, { y: 46, opacity: 0, duration: 1.1, ease: "expo.out", stagger: 0.08, scrollTrigger: { trigger: g, start: "top 85%", once: true } });
    });
    $(".passport__sky") && G.to(".passport__sky", { yPercent: 8, ease: "none", scrollTrigger: { trigger: "#passport", start: "top bottom", end: "bottom top", scrub: true } });
    $$(".stamp-card").forEach((c, i) => G.from(c, { y: 50, opacity: 0, duration: 1, ease: "expo.out", delay: (i % 3) * 0.07, scrollTrigger: { trigger: c, start: "top 92%", once: true } }));
  }

  /* ---------- Footer word: fills its width, then fills with colour ---------- */
  const fw = $("#footWord");
  const fitFoot = () => {
    if (!fw) return;
    fw.style.fontSize = "";
    const base = parseFloat(getComputedStyle(fw).fontSize);
    const range = document.createRange();
    range.selectNodeContents(fw);
    const w = range.getBoundingClientRect().width;
    if (w) fw.style.fontSize = Math.min(base * 1.8, (base * fw.clientWidth * 0.96) / w) + "px";
  };
  fitFoot();
  if ("ResizeObserver" in window) {
    let lastW = 0;
    new ResizeObserver(([e]) => { const w = Math.round(e.contentRect.width); if (w !== lastW) { lastW = w; fitFoot(); fitTitle(); anim && ST.refresh(); } }).observe(document.body);
  }
  if (document.fonts) document.fonts.ready.then(() => { fitFoot(); fitTitle(); });
  if (fw) {
    if (anim) {
      fw.style.setProperty("--fill", "0%");
      ST.create({ trigger: ".foot", start: "top 85%", end: "bottom bottom", scrub: true, onUpdate: (s) => fw.style.setProperty("--fill", (s.progress * 100).toFixed(1) + "%") });
    } else fw.style.setProperty("--fill", "100%");
  }
  if (anim) addEventListener("load", () => ST.refresh());
})();
